
const forms = [
  {id: 0, form: 'IT Purchase Request', path: 'https://forms.cloud.microsoft/r/SyBtDxyaiq', info: 'Use this form to request a purchase from IT.'},
  {id: 1, form: 'IT On-boarding & Account Creation Requests', path: 'https://forms.cloud.microsoft/r/i7t9ys7hqH', info: 'Use this form to request a user/email account be created on behalf of someone.'},
  {id: 2, form: 'Representative Account Creation Request', path: 'https://forms.cloud.microsoft/r/4funV8V47B', info: 'Use this form to request the creation of a rep account.'},
]

export default forms